import SectionHero from "components/SectionHero/SectionHero";
import SectionSliderNewCategories from "components/SectionSliderNewCategories/SectionSliderNewCategories";
import { useEffect, useState } from "react";
import SectionGridFeaturePlaces from "./SectionGridFeaturePlaces";
import BackgroundSection from "components/BackgroundSection/BackgroundSection";
import BgGlassmorphism from "components/BgGlassmorphism/BgGlassmorphism";
import { TaxonomyType } from "data/types";
import { useNavigate } from "react-router-dom";
import api from "../../api";

function PageHome() {
  const navigate = useNavigate();
  const [user, setUser] = useState(null);
  const [userType, setUserType] = useState(null);
  const [loading, setLoading] = useState(true);
  const [debugInfo, setDebugInfo] = useState<{
    getUserResponse?: any;
    getUserStatus?: number;
    getUserData?: any;
    userDataSet?: any;
    userId?: any;
    getCompanyTypeResponse?: any;
    getCompanyTypeStatus?: number;
    getCompanyTypeData?: any;
    companyTypeSet?: string;
    originalCompanyType?: string;
    entityId?: number;
    userDataError?: any;
    userDataErrorDetails?: any;
    userDataErrorMessage?: string;
    companyTypeError?: any;
    companyTypeErrorDetails?: any;
    companyTypeErrorMessage?: string;
    fetchUserDataError?: any;
    fetchUserDataErrorMessage?: string;
  }>({});

  useEffect(() => {
    localStorage.setItem('last_page', '/');
    setUserType(localStorage.getItem('company_type'));
    fetchUserData();
  }, []);

  const fetchUserData = async () => {
    try {
      api.getUser((response) => {
        setDebugInfo(prev => ({
          ...prev,
          getUserResponse: response,
          getUserStatus: response.status,
          getUserData: response.data
        }));

        if (response.status === 200) {
          let userData = null;
          
          if (response.data?.data) {
            userData = response.data.data;
          } else if (response.data?.user) {
            userData = response.data.user;
          } else if (response.data && typeof response.data === 'object' && response.data.id) {
            userData = response.data;
          }

          if (userData && userData.id) {
            setUser(userData);
            
            setDebugInfo(prev => ({
              ...prev,
              userDataSet: userData,
              userId: userData.id
            }));
            
            api.getCompanyType(
              userData.id,
              (typeResponse) => {
                setDebugInfo(prev => ({
                  ...prev,
                  getCompanyTypeResponse: typeResponse,
                  getCompanyTypeStatus: typeResponse.status,
                  getCompanyTypeData: typeResponse.data
                }));

                if (typeResponse.status === 200) {
                  let companyType = null;
                  let entityId = null;
                  
                  if (typeResponse.data?.company_type) {
                    companyType = typeResponse.data.company_type;
                    entityId = typeResponse.data.entity_id;
                  } else if (typeResponse.data?.data?.type) {
                    companyType = typeResponse.data.data.type;
                    entityId = typeResponse.data.data.entity_id;
                  } else if (typeResponse.data?.type) {
                    companyType = typeResponse.data.type;
                    entityId = typeResponse.data.entity_id;
                  } else if (typeResponse.data?.entity) {
                    companyType = typeResponse.data.entity;
                    entityId = typeResponse.data.entity_id;
                  }

                  if (companyType) {
                    const normalizedType = companyType === 'agencies' ? 'agency' : 
                                         companyType === 'brandowners' ? 'brand' : 
                                         companyType;
                    
                    setUserType(normalizedType);
                    
                    setDebugInfo(prev => ({
                      ...prev,
                      companyTypeSet: normalizedType,
                      originalCompanyType: companyType,
                      entityId: entityId
                    }));
                  } else {
                    setDebugInfo(prev => ({
                      ...prev,
                      companyTypeError: 'No valid company type found'
                    }));
                  }
                } else {
                  setDebugInfo(prev => ({
                    ...prev,
                    companyTypeError: 'Company type request failed',
                    companyTypeErrorDetails: typeResponse
                  }));
                }
                setLoading(false);
              },
              (error) => {
                setDebugInfo(prev => ({
                  ...prev,
                  companyTypeError: error,
                  companyTypeErrorMessage: error.message || 'Unknown error'
                }));
                setLoading(false);
              }
            );
          } else {
            setDebugInfo(prev => ({
              ...prev,
              userDataError: 'No valid user data found'
            }));
            setLoading(false);
          }
        } else {
          setDebugInfo(prev => ({
            ...prev,
            userDataError: 'User request failed',
            userDataErrorDetails: response
          }));
          setLoading(false);
        }
      });
    } catch (error) {
      setDebugInfo(prev => ({
        ...prev,
        fetchUserDataError: error,
        fetchUserDataErrorMessage: error.message || 'Unknown error'
      }));
      setLoading(false);
    }
  };

  const getCarouselHeading = () => {
    if (!userType) return "Assignments you might be interested in";
    
    return userType === 'agency' 
      ? "Assignments you might be interested in – Brands" 
      : "Assignments you might be interested in – Agencies";
  };

  if (loading) {
    return (
      <div className="nc-PageHome relative overflow-hidden">
        <BgGlassmorphism />
        <div className="container relative">
          <SectionHero className="pt-10 lg:pt-16 lg:pb-16" />
          <div className="flex justify-center items-center py-16">
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-500"></div>
            <span className="ml-3 text-gray-600">Loading your personalized matches...</span>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="nc-PageHome relative overflow-hidden">
      {/* GLASSMOPHIN */}
      <BgGlassmorphism />

      <div className="container relative">
        {/* SECTION HERO */}
        <SectionHero 
          className="pt-10 lg:pt-16 lg:pb-16" 
          userType={userType}
        />        
        {/* SECTION */}
        {/* <div className="relative py-16">
          <SectionGridFeaturePlaces />
        </div> */}
        
        {/* SECTION 1 */}

        {user && user.id && userType === 'agency' && (
          <div style={{ whiteSpace: 'nowrap' }}>
            <SectionSliderNewCategories
              heading={getCarouselHeading()}
              subHeading=""
              categoryCardType="carousel"
              itemPerRow={5}
              uniqueClassName="PageHome_carousel"
              sessionUser={debugInfo.entityId?.toString() || user.id.toString()}
              userType={userType}
              useScoring={true}
              limit={15}
            />
          </div>
        )}

        {user && !user.id && !loading && (
          <div className="flex flex-col items-center justify-center py-16">
            <div className="text-center">
              <h3 className="text-lg font-medium text-red-900 mb-2">
                User data issue detected
              </h3>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default PageHome;
